export const uploadEmployeePayslipsPath = "admin/uploadEmployeePayslips";
export const getEmployeePayslipsPath    = (userId) => `admin/getEmployeePayslips?userId=${userId}`;




//toast flas globally
export const featureFlags = {
  useNewToastSystem: false, // Start with OLD system, migrate to NEW
};
// Overtime Settings APIs
export const createOvertimePath = "admin/createOvertime";
export const getOvertimeListPath = (userId) => `admin/getOvertimeList?userId=${userId}`;
export const updateOvertimePath = "admin/updateOvertime";
export const deleteOvertimePath = "admin/deleteOvertime";
export const assignEmployeeOvertimePath = "admin/assignEmployeeOvertime";

// FIXED: This should point to getOvertimeStaffList, not getStaffList
export const getOvertimeStaffListPath = (userId, overtimeId) => 
  `admin/getOvertimeStaffList?userId=${userId}&overtimeId=${overtimeId}`;

// If you need a separate endpoint for getting all staff (without overtime filter)
export const getAllStaffListPath = (userId) => 
  `admin/getStaffList?userId=${userId}`;

//  Onboarding
// Commo
export const updateEnableFacePath = "admin/updateEnableFace";
export const getModuleLeaveList = "admin/getModuleLeaveList/";
export const getCompanyProfileListPath = "admin/getCompanyProfileList?userId=";
export const loginPath = "userLogin";
export const checkUserRecordsPath = "admin/checkUserRecords?userId=";
export const getEmployeeStaffListPath = "admin/getEmployeeStaffList?userId=";

export const fetchDesignationListPath = "admin/getDesignationList?userId=";
export const getAppModulesListPath = "admin/getAppModulesList?userId=";
export const createDesignationPath = "admin/createDesignation";
export const updateDesignationPath = "admin/updateDesignation";
export const deleteDesignationPath = "admin/deleteDesignation";

export const getEmployeeRecordsPath = `employee/getEmployeeRecords?staffId=`;
export const getBloodGroupPath = "getBloodGroup";
export const getQualificationsPath = "getQualifications";
export const getMaritalStatusPath = "getMaritalStatus";
export const getGenderPath = "getGender";
export const getStatesPath = "getStates";
export const getCountryPath = "getCountry";
export const getRelationshipPath = "getRelationship";
export const saveEmployeeOnboardPath = "employee/saveEmployeeOnboard";
// reset Password
export const getAdminRecordsPath = "getAdminRecords?userId=";
export const passwordResetPath = "passwordReset";

// Admin ================================================
// Notification
export const getNotificationsPath = "admin/getNotifications?userId=";
export const notifyApproveRequestPath = "admin/notifyApproveRequest";
export const createAnnouncementTypePath = "admin/createAnnouncementType";
export const getAnnouncementTypesPath = "admin/getAnnouncementTypes?userId="
export const updateAnnouncementTypePath = "admin/updateAnnouncementType"
export const deleteAnnouncementTypePath = "admin/deleteAnnouncementType"
export const announceEmpListPath = "admin/announceEmpList"
export const announceEmpGroupPath = "admin/announceEmpGroup"
export const saveAnnouncementPath = "admin/saveAnnouncement"
export const recentDraftListPath = "admin/recentDraftList"
export const getAnnouncementTitlePath = "admin/getAnnouncementTitle"

// Dashboard
export const getDashboardDatas = "admin/getDashboardDatas";
export const getBranchList = "admin/getBranchList?userId=";
export const createBranch = "admin/createBranch";
export const dashboardChartPath = "admin/attendanceSummary";

export const getMasterRolePermissionsPath = "admin/getMasterRolePermissions";
export const saveMasterRolePermissionsPath = "admin/saveMasterRolePermissions";
export const getRolePermissionsPath = "admin/getRolePermissions";
export const saveRolePermissionsPath = "admin/saveRolePermissions";
export const saveEmployeeWishMessagePath = "admin/saveEmployeeWishMessage";
export const updateEmployeeWishMessagePath = "admin/updateEmployeeWishMessage";

// Employee (Employee management)
export const createEmployerIdPath = "admin/createEmployerId";
export const updateEmployerIdPath = "admin/updateEmployerId";

export const getEmployeeManageListPath = "admin/getEmployeeManageList?userId=";
export const updateEmployerManageListPath = "admin/updateEmployerManageList";
export const getRMTeamLeaderListPath = (individualStaffId, userId) => { return `admin/getRMTeamLeaderList?individualStaffId=${individualStaffId}&userId=${userId}` }
export const getRMManagerListPath = (individualStaffId, userId) => { return `admin/getRMManagerList?individualStaffId=${individualStaffId}&userId=${userId}` }
export const getRMHeadListPath = (individualStaffId, userId) => { return `admin/getRMHeadList?individualStaffId=${individualStaffId}&userId=${userId}` }

export const getEmployerIdListPath = "admin/getEmployerIdList?userId=";
export const multipleStaffPath = "multipleStaff";
export const getEmployeeAttendanceListPath = "admin/getEmployeeAttendanceList?userId=";
export const getEmployeeBankListPath = "admin/getEmployeeBankList?userId=";
export const getEmployeeSalaryListPath = "admin/getEmployeeSalaryList?userId=";
export const getEmployeeLeaveBalListPath = "admin/getEmployeeLeaveBalList?userId=";
export const getEmployeePenaltyListPath = "admin/getEmployeePenaltyList?userId=";
export const getEmployeeInidvidualStaffListPath = "admin/getEmployeeInidvidualStaffList?staffId=";
export const saveClientNewEmployeePath = "admin/saveClientNewEmployee";
export const empAttendanceWorktypePath = "admin/empAttendanceWorktype";
export const empAttendanceModesPath = "admin/empAttendanceModes";
export const getStaffDocumentListPath = "admin/getStaffDocumentList?staffId=";
export const getDocumentsListPath = "admin/getDocumentsList";
export const AddEmployeeDocumentsPath = "admin/AddEmployeeDocuments";
export const getEmployeeTypeListPath = "admin/getEmployeeTypeList";
export const updateEmployementDetailsPath = "admin/updateEmployementDetails";
export const updatePastEmployementDetailsPath = "admin/updatePastEmployementDetails";
export const empLeavePolicyPath = "admin/empLeavePolicy";
export const empLeaveBalancePath = "admin/empLeaveBalance";

export const deactivateEmployeePath = "admin/deactivateEmployee";
export const updateEmployeeBankAccountsPath = "admin/updateEmployeeBankAccounts";

export const updateEmployeeBankChequePath = "admin/updateEmployeeBankCheque";
export const updateAddressDetailsPath = "admin/updateAddressDetails";
export const updateQualificationDetailsPath = "admin/updateQualificationDetails";
export const getEmployeePermissionListPath = "admin/getEmployeePermissionList?userId="
export const adminSystemAccessPath = "admin/adminSystemAccess"
export const taxDocumentsPath = "admin/taxDocuments"
export const taxDocumentsApproveOrRejectPath = "admin/taxDocumentsApproveOrReject"
export const deleteEmployeeDocumentsPath = "admin/deleteEmployeeDocuments"
export const editEmployeeDocumentsPath = "admin/editEmployeeDocuments"
export const tdsClaimFormsPath = "admin/tdsClaimForms"
export const submitTDSClaimFormPath = "admin/submitTDSClaimForm"



// Payroll
export const getDeductionListPath = "admin/getDeductionList";
export const getAllowanceListPath = "admin/getAllowanceList";
export const adminCreateSalaryTemplatePath = "admin/createPayrollModel";
export const getPayrollModelListPath = "admin/getPayrollModelList?userId=";
export const deletePayrollModelPath = "admin/deletePayrollModel";
export const updatePayrollModelPath = "admin/updatePayrollModel";
export const getStaffPayrollModelListPath = (userId, PayrollModelId, branchId, departmentId) => {
  return `admin/getStaffPayrollModelList?userId=${userId}&PayrollModelId=${PayrollModelId}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const assignEmployeePayrollModelPath = "admin/assignEmployeePayrollModel";
export const calculatePayrollPath = "admin/calculateActualSalary";
export const savePayrollEmployeePath = "admin/savePayrollEmployee";

export const adminGetBloodGroup = "admin/getBloodGroup";
export const updatePersonalDetailsPath = "admin/updatePersonalDetails";
export const getEmployeeBankListFuncPath = (userId, staffId) => {
  return `admin/getEmployeeBankList?userId=${userId}&staffId=${staffId}`;
};
export const updateBankAccountDetailsPath = "admin/updateBankAccountDetails";
export const deleteAttendanceModulePath = "admin/deleteAttendanceModule";
export const getAttendanceModulePath = "admin/getAttendanceModule?userId=";
export const getStaffAttendanceListPath = (userId, attendanceId, branchId, departmentId) => {
  return `admin/getStaffAttendanceList?userId=${userId}&attendanceId=${attendanceId}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const assignEmployeeAttendancePath = "admin/assignEmployeeAttendance";

export const getRunPayrollEmployeePath = "admin/getRunPayrollEmployee";
export const getIncentivePayrollEmployeePath = "admin/getIncentivePayrollEmployee";
export const addIncentiveTypeStaffPath = "admin/addIncentiveTypeStaff";

export const calculateEarnedSalaryPath = "admin/calculateEarnedSalary";

export const getPaymentHistoryPath = "admin/getPaymentHistory";
export const overtimePaySettingsPath = "admin/overtimePaySettings";

export const earlyFineSettingsPath = "admin/earlyFineSettings";
export const lateFineSettingsPath = "admin/lateFineSettings";
export const getOvertimePayDetailsPath = "admin/getOvertimePayDetails";
export const getEarlyFineDetailsPath = "admin/getEarlyFineDetails";
export const getLateFineDetailsPath = "admin/getLateFineDetails";

export const savePaymentHistoryPath = "/admin/savePaymentHistory";

export const getTDSGeneralRulePath = "admin/getTDSGeneralRule?userId="
export const saveTDSGeneralRulePath = "admin/saveTDSGeneralRule"

export const getTDSValidationRulePath = "admin/getTDSValidationRule?userId="

export const getTDSRecentActivityPath = "https://internaltestinghrms.sktexus.com/api/admin/getTDSRecentActivity"
export const saveTDSValidationRulePath = "admin/saveTDSValidationRule"

export const getNotificationRulePath = "admin/getNotificationRule?userId="
export const saveNotificationRulePath = "admin/saveNotificationRule"

export const getTDSDashboardDataPath = 'admin/getTDSDashboardData'
export const getTDSDashboardPath = 'admin/getTDSDashboard'
export const getEmployeePayrollRecordsPath = 'admin/getEmployeePayrollRecords'
export const getTDSDeclarationFormPath = 'admin/getTDSDeclarationForm'
export const tdsRequestFormPath = 'admin/tdsRequestForm'
// pay roll summary 
export const getEarningDetailsPath = "/admin/getEarningDetails";
export const getStatutoryComplianceDetailsPath = "/admin/getStatutoryComplianceDetails";

// reimbursement
export const getReimbursementPayrollEmployeePath = "admin/getReimbursementPayrollEmployee";

export const saveOfflinePaymentPath = "admin/saveOfflinePayment";

export const saveFinalizePayrollPath = "admin/saveFinalizePayroll";

// Attendance
export const dailyAttendancePath = "admin/dailyAttendance";
export const employeeFullAttendanceRecordPath = "admin/employeeFullAttendanceRecord";
export const liveAttendancePath = `admin/liveAttendance`;
export const editAttendancePath = "admin/editAttendance";
export const employeeAttendanceDashboardPath = "admin/employeeAttendanceDashboard";
export const employeeIndividualAttendancePath = "admin/employeeIndividualAttendance";
export const editAbsentAsPresentAttendancePath = "admin/editAbsentAsPresentAttendance";

export const getForm22Path = "admin/getForm22?userId="
export const createForm22PAth = "admin/createForm22"


export const addWorkBasicPayPath = "admin/addWorkBasicPay";
export const addIncentiveStaffPath = "admin/addIncentiveStaff";
export const addReimbursementStaffPath = "admin/addReimbursementStaff";
export const addBonusWagePath = "admin/addBonusWage";
export const addOtherEarningsPath = "admin/addOtherEarnings";
export const addOtherDeductionsPath = "admin/addOtherDeductions";
export const addAdvancePath = "admin/addAdvance";

export const getWorkBasicPayPath = "admin/getWorkBasicPay";
export const getIncentivePath = "admin/getIncentive";
export const getReimbursementPath = "admin/getReimbursement";
export const getBonusWagePath = "admin/getBonusWage";
export const getOtherEarningsPath = "admin/getOtherEarnings";
export const getOtherDeductionsPath = "admin/getOtherDeductions";

// Setting ===========================================================
export const getMyBreaksListPath = `admin/getMyBreaksList?userId=`;
export const createMyBreaksPath = "admin/createMyBreaks";
export const updateBreaksPath = "admin/updateBreaks";
export const deleteBreaksPath = "admin/deleteBreaks";
export const getBreakStaffListPath = (userId, breakId, branchId, departmentId) => {
  return `admin//getBreakStaffList?userId=${userId}&breakId=${breakId}&branchId=${branchId}&departmentId=${departmentId}`
}
export const assignEmployeeBreakPath = "admin/assignEmployeeBreak"

export const getGovernmentHolidayListPath = "admin/getGovernmentHolidayList";
export const getHolidayMainPath = "admin/getHolidayMain?userId=";
export const deleteHolidayMainPath = "admin/deleteHolidayMain";
export const getStaffHolidayListPath = (user_id, id, branchId, departmentId) => {
  return `admin/getStaffHolidayList?userId=${user_id}&holidayId=${id}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const insertHolidayMainPath = `admin/insertHolidayMain`;

export const getMyHolidayListPath = "admin/getMyHolidayList?holidayId=";
export const createMyHolidayPath = `admin/createMyHoliday`;
export const updateMyHolidayPath = "/api/admin/updateMyHoliday";
export const deleteMyHolidayPath = "admin/deleteMyHoliday";
export const assignHolidayEmployeePath = "admin/assignHolidayEmployee";

export const deleteLeaveMainPath = "admin/deleteLeaveMain";
export const getLeaveMain = "admin/getLeaveMain?userId=";
export const insertLeaveMainPath = `admin/insertLeaveMain`;
export const getStaffLeaveListPath = (user_id, leaveId, branchId, departmentId) => {
  return `admin/getStaffLeaveList?userId=${user_id}&leaveId=${leaveId}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const assignLeaveEmployee = "admin/assignLeaveEmployee";

export const insertLeavePath = "admin/insertLeaveModule";
export const updateLeavePath = "admin/updateLeaveCarryForward";
export const deleteLeavePath = "admin/deleteLeave";
export const getLeavePath = `admin/getModuleLeaveList?moduleId=`;

export const getAttendanceGeneralSettingsPath =
  "admin/getAttendanceGeneralSettings?moduleId=";
export const getAttendOptionsPath = "admin/getAttendOptions";
export const fetchLeavePath = "admin/fetchLeave?userId=";

export const attendanceGeneralSettingsPath = "admin/attendanceGeneralSettings";
export const employeeCheckInAndOutResetPath =
  "admin/employeeCheckInAndOutReset";

// Department
export const getDepartmentListPath = "admin/getDepartmentList?userId=";
export const createDepartmentPath = "admin/createDepartment";
export const updateDepartmentPath = "admin/updateDepartment";
export const deleteDepartmentPath = "admin/deleteDepartment";

export const fetchBusinessTypeListPath = "admin/getBusinessTypeList?userId=";
export const updateCompanyDetailsPath = "admin/UpdateCompanyDetails";
export const UpdateCompanyLogoPath = "admin/UpdateCompanyLogo";
export const getReportTypePath = "admin/getReportType?report_type=";

export const getStaffEmployeeDepartmentPath = (userId, departmentId, branchId) => {
  return `admin/getStaffEmployeeDepartment?userId=${userId}&departmentId=${departmentId}&branchId=${branchId}`;
};
export const assignEmployeeDepartmentPath = "admin/assignEmployeeDepartment";
export const getEmployeeTodayCheckInListPath = "admin/getEmployeeTodayCheckInList";

// Role
export const updateRolesPath = "admin/updateRoles";
export const deleteRolesPath = "admin/deleteRoles";
export const getEmployeeListPath = "admin/getEmployeeList";
export const saveSettingsRolePermissionsPath =
  "admin/saveSettingsRolePermissions";
export const assignDesignationRolePermissionsPath =
  "admin/assignDesignationRolePermissions";
// Shift
export const getMyShiftListPath = "admin/getMyShiftList?userId=";
export const createMyShiftPath = "admin/createMyShift";
export const getStaffListPath = (user_id, id, branchId, departmentId) => {
  return `admin/getStaffList?userId=${user_id}&shiftId=${id}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const updateShiftPath = "admin/updateShift";
export const deleteShiftPath = "admin/deleteShift";
export const assignEmployeeShiftPath = "admin/assignEmployeeShift";
export const updateBranchPath = "admin/updateBranch";
export const deleteBranchPath = "admin/deleteBranch";
// Tracking
export const getEmpLocationAllPath = "admin/getEmpLocationAll?userId=";
export const getTrackingEmployeesPath = (userId, branchId) => {
  return `admin/getTrackingEmployees?userId=${userId}&branchId=${branchId}`;
};
export const getEmployeeLatAndLongPath = (value, branchId, date) => {
  return `admin/getEmployeeLatandLong?staffId=${value}&branchId=${branchId}&departmentId=0&selectedDate=${date}`;
};

// Super Admin =======================================================
// package
export const getPackageAppModulesListPath = "admin/getAppModulesList";
export const getAdminUserListPath = "superior/getAdminUserList";
export const getModuleListPath = "superior/getModuleList";
export const getBusinessTypeListPath = "admin/getBusinessTypeList";
export const saveNewAdminUserPath = "superior/saveNewAdminUser";

// My Team
export const getSubAdminListPath = "admin/getSubAdminList?userId=";
export const createSubAdminPath = "admin/createSubAdmin";
export const updateSubAdminPath = "admin/updateSubAdmin";
export const deleteSubAdminPath = "admin/deleteSubAdmin";
export const getAdminAssignedRolesPath = "admin/getAdminAssignedRoles";
export const getEmpPfVariableListPath = "admin/getEmpPfVariableList?userId=";

export const getCalendarMonthListPath = "admin/getCalendarMonthList";
export const getParentRolePermissionsPath = "admin/getParentRolePermissions";
export const saveParentRolePermissionsPath = "admin/saveParentRolePermissions";

// Audit ------------------------------------------------------------------
export const createAuditModelPath = "admin/createAuditModel";
// export const getAuditModelListPath = "admin/getAuditModelList?userId=";
export const getAuditModelListPath = (userId, outletId) => {
  return `admin/getAuditModelList?userId=${userId}&outletId=${outletId}`;
};
export const updateAuditModelPath = "admin/updateAuditModel";
export const deleteAuditModelPath = "admin/deleteAuditModel";
export const assignEmployeeAuditModelPath = "admin/assignEmployeeAuditModel";
export const getStaffAuditModelListPath = (userId, auditModelId) => {
  return `admin/getStaffAuditModelList?userId=${userId}&auditModelId=${auditModelId}`;
};
export const getQuestionnaireStaffListPath = (
  userId,
  auditModelId,
  branchId
) => {
  return `admin/getQuestionnaireStaffList?userId=${userId}&auditModelId=${auditModelId}&branchId=${branchId}`;
};

export const getAssignedStaffsQuestionsListPath = (
  userId,
  outletId,
  staffId
) => {
  return `admin/getAssignedStaffsQuestionsList?userId=${userId}&staffId=${staffId}&outletId=${outletId}`;
};

export const getEmployeeAssignedAuditListPath =
  "admin/getEmployeeAssignedAuditList?userId=";
export const getEmployeeQuestionAnswerList = (userId, staffId) => {
  return `admin/getEmployeeQuestionAnswerList?userId=${userId}&staffId=${staffId}`;
};
export const getStaffBranchAssignListPath = (userId, branchId) => {
  return `admin/getStaffBranchAssignList?userId=${userId}&branchId=${branchId}`;
};

export const getQuestionAnswerForStaffListPath = (
  userId,
  auditModelId,
  outletId,
  frequency,
  staffId
) => {
  return `admin/getQuestionAnswerForStaffList?userId=${userId}&auditModelId=${auditModelId}&outletId=${outletId}&frequency=${frequency}&staffId=${staffId}`;
};

export const assignBranchToEmployeePath = "admin/assignBranchEmployee";
export const updateFrequencyOutletPath = "admin/updateFrequencyOutlet";

export const createOutletModelPath = "admin/createOutletModel";
export const updateOutletModelPath = "admin/updateOutletModel";
export const getOutletListPath = "admin/getOutletList?userId=";
export const deleteOutletModelPath = "admin/deleteOutletModel";
export const getOutletAssignedStaffListPath = (outletId, userId, branchId, departmentId) => {
  return `admin/getOutletAssignedStaffList?outletId=${outletId}&userId=${userId}&branchId=${branchId}&departmentId=${departmentId}`;
};
export const assignOutLetEmployeePath = "admin/assignOutLetEmployee";
export const assignOutLetEmployeeAllPath = "/admin/assignOutLetEmployeeAll";

// Audit report ----------------------------------------
export const getAuditModuleReportPath = (
  userId,
  staffId,
  moduleId,
  branchId,
  customDate
) => {
  return `admin/getAuditModuleReport?userId=${userId}&staffId=${staffId}&moduleId=${moduleId}&branchId=${branchId}&customDate=${customDate}`;
};
// Reports ------------------------------------
export const customAttendancePath = "admin/customAttendance";
export const reportGenerationPath = "admin/reportGeneration";
export const reportGenerationListPath = "admin/reportGenerationList";




// TDS FORM !12bb

export const manageTDSFormsPath = "admin/manageTDSForms";
// review TDS Forms

export const getTDSReviewQueueDetailsPath = "admin/getTDSReviewQueueDetails";
export const getReviwQueueDeshbordPath = "employee/getReviwQueueDeshbord";
